module.exports = __webpack_public_path__ + "static/media/burkina-faso.73f1e6e4.svg";